var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.indicatorStyles)},[_c('div',{staticClass:"vcl-thinking__indicator"}),_c('div',{staticClass:"vcl-thinking__indicator"}),_c('div',{staticClass:"vcl-thinking__indicator"})])
}
var staticRenderFns = []

export { render, staticRenderFns }